<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_collabtask_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="任务编号">
							<c-input name="task_code"></c-input>
						</m-search-item>
						<m-search-item label="任务标题">
							<c-input name="task_title"></c-input>
						</m-search-item>
						<m-search-item label="任务类型">
							<c-select name="task_type_ids" async multiple @search="searchTaskType"></c-select>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="task_states" :options="collabTaskStateDic" multiple></c-select>
						</m-search-item>
						<m-search-item label="负责人">
							<c-select name="user_ids" async multiple @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="创建人">
							<c-select name="create_user_ids" async multiple @search="searchUser"></c-select>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="完成时间" colspan="2">
							<c-datetime range start-name="finish_start_date" end-name="finish_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_collabtask_add')" v-lock="lock('b_collabtask_add')" prepend-icon="tf-add" @click="editTask()">创建协同任务</c-button>
					<c-button v-if="auth('b_collabtask_export')" v-lock="lock('b_collabtask_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_collabtask_export')" v-lock="lock('b_collabtask_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_collabtask_export')" v-lock="lock('b_collabtask_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_collabtask_export')" v-lock="lock('b_collabtask_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_collabtask_print')" v-lock="lock('b_collabtask_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_collabtask_log')" v-lock="lock('b_collabtask_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<!--任务编号-->
				<template #task_code="{data}">
					<c-link @click="openDetail(data)">{{data.task_code}}</c-link>
				</template>

				<!--任务编号-->
				<template #task_title="{data}">
					<c-link @click="openDetail(data)">{{data.task_title}}</c-link>
				</template>

				<!--任务类型-->
				<template #type_name="{data}">
					<c-state :color="data.color" tag>{{data.type_name}}</c-state>
				</template>

				<!--状态-->
				<template #task_state="{data}">
					<c-state dict="collabTaskStateDic" tag :value="data.task_state"></c-state>
				</template>

				<!--附件-->
				<template #attachment_json="{data}">
					<c-file-list v-if="parseFiles(data.attachment_json).length" :value="parseFiles(data.attachment_json)" size="mini"></c-file-list>
					<span v-else>-</span>
				</template>

				<!--任务来源-->
				<template #ref_type="{data}">
					<span>{{refTypeText(data.ref_type)}}</span>
				</template>

				<!--来源单号-->
				<template #ref_code="{data}">
					<order-link v-if="data.ref_type" :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
					<span v-else>-</span>
				</template>

				<!--处理附件-->
				<template #handle_attachment_json="{data}">
					<c-file-list v-if="parseFiles(data.handle_attachment_json).length" :value="parseFiles(data.handle_attachment_json)" size="mini"></c-file-list>
					<span v-else>-</span>
				</template>

				<!--响应时长（创建→接受，接受后才有）-->
				<template #response_seconds="{data}">
					<span>{{durationText(data.response_seconds)}}</span>
				</template>

				<!--处理时长（响应→完成）-->
				<template #handle_seconds="{data}">
					<span>{{durationText(data.handle_seconds)}}</span>
				</template>
				
				<!--总时长（创建→完成/当前）-->
				<template #total_seconds="{data}">
					<span>{{durationText(data.total_seconds)}}</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="175"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="openDetail(data)">查看</c-table-button>
						<c-table-button v-if="auth('b_collabtask_accept') && data.task_state == 1" icon="tf-accept" @click="acceptTask(data)">接受</c-table-button>
						<c-table-button v-if="auth('b_collabtask_finish') && data.task_state == 2" icon="tf-finish" @click="finishTask(data)">完成</c-table-button>
						<c-table-button v-if="auth('b_collabtask_restart') && data.task_state == 3" icon="tf-restart" @click="restartTask(data)">重启</c-table-button>
						<c-table-button v-if="auth('b_collabtask_accept') && data.task_state == 2" icon="tf-cancel" @click="cancelAcceptTask(data)">取消接受</c-table-button>
						<c-table-button v-if="auth('b_collabtask_transfer')" v-lock="lock('b_collabtask_transfer')" icon="tf-transfer" @click="transferTask(data)">转移</c-table-button>
						<c-table-button v-if="auth('b_collabtask_print')" v-lock="lock('b_collabtask_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_collabtask_edit')" v-lock="lock('b_collabtask_edit')" icon="tf-edit" @click="editTask(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_collabtask_edit')" v-lock="lock('b_collabtask_edit')" icon="tf-trash" color="red" @click="removeTask(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>

		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		props: {
			viewId: [String, Number]
		},

		data() {
			return {
				workType: 51
			}
		},

		computed: {
			...mapState(['collabTaskStateDic'])
		},

		methods: {
			/****解析附件JSON数组****/
			parseFiles(json) {
				return Array.isArray(json) ? json : [];
			},

			/****任务来源名称****/
			refTypeText(refType) {
				switch ((refType || '').toString()) {
				case '3':
					return '生产工单';
				case '13':
					return '生产任务';
				default:
					return '-';
				}
			},

			/****时长展示文本（取最高两级非零单位，如 1天3时、7时27分、12分33秒）****/
			durationText(seconds) {
				if (seconds === null || seconds === undefined || seconds === '') return '-';
				seconds = parseInt(seconds);
				if (isNaN(seconds) || seconds < 0) return '-';
				if (seconds === 0) return '0秒';
				let units = [
					{value: 86400, name: '天'},
					{value: 3600, name: '时'},
					{value: 60, name: '分'},
					{value: 1, name: '秒'}
				];
				let parts = [];
				for (let unit of units) {
					let count = Math.floor(seconds / unit.value);
					seconds %= unit.value;
					if (count) {
						parts.push(count + unit.name);
					}
					if (parts.length >= 2) break;
				}
				return parts.join('');
			},

			/*******搜索任务类型*****************/
			searchTaskType(keyword, resolve){
				this.request({
					url: '/collab/task/type/list',
					data: {
						type_name: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.type_name,
								value: item.id
							}
						}));
					}
				})
			},

			/*******搜索用户*****************/
			searchUser(keyword, resolve){
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						keyword: keyword
					},
					success: data => {
						resolve(data);
					}
				})
			},

			/******打开任务详情（详情内操作后刷新列表）*******/
			openDetail(data) {
				this.globalDialog('collabTaskDetail', {props: {id: data.id}}, () => this.$refs.view.update());
			},

			/******创建/编辑协同任务*******/
			editTask(data) {
				this.globalDialog('collabTaskEdit', {data}, () => this.$refs.view.update());
			},

			/******接受任务*******/
			acceptTask(data) {
				this.$confirm({
					message: '确认接受任务【' + data.task_title + '】？',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/accept',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '已接受任务',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******取消接受任务*******/
			cancelAcceptTask(data) {
				this.$confirm({
					message: '确认取消接受任务【' + data.task_title + '】？任务将退回待响应状态',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/accept/cancel',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '已取消接受',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******完成任务（填写处理记录）*******/
			finishTask(data) {
				this.globalDialog('collabTaskFinish', {data}, () => this.$refs.view.update());
			},

			/******重启任务*******/
			restartTask(data) {
				this.$confirm({
					message: '确认重启任务【' + data.task_title + '】？任务将回到执行中状态，历史处理记录将保留',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/restart',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '任务已重启',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {}
				});
			},

			/******转移任务*******/
			transferTask(data) {
				this.globalDialog('collabTaskTransfer', {data}, () => this.$refs.view.update());
			},

			/******删除任务*******/
			removeTask(data) {
				this.$confirm({
					message: '确认删除协同任务【' + data.task_title + '】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/collab/task/remove',
							data: {id: data.id},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.color-dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		margin-right: 6px;
		border-radius: 50%;
		vertical-align: middle;
	}
</style>
